import React, { useEffect, useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation } from "react-router-dom";
import "./css/banner.css";
import ReusableCollapse from "./ReusableCollapse";
import useScreenSize from "../Hook/UseScreenSize";
const NavComponent = () => {
  const { width } = useScreenSize();
  return (
    <>
      <div className="container-fluid navbar-container">
        <Navbar
          expand="lg"
          fixed="top"
          /*  style={{zIndex:'2',top:'0px',backgroundColor:'rgb(31,33,72)'}}*/
        >
          <Container>
            <div className="second-nav-brand">
              <img
                className="img-fluid"
                src={"../assets/images/canvendor_blue_transparent_logo.png"}
                width={150}
                height={30}
              />
            </div>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              style={{
                border: "2px solid white",
                backgroundColor: "rgba(255, 255, 255, 0.527)",
              }}
            />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link>
                  <Link to="/">Home</Link>{" "}
                </Nav.Link>

                <li className="dropdown me-0 dropdown-link">
                  <Link to="" className="nav-link ">
                    Solutions
                    <i
                      class="fa fa-caret-down"
                      aria-hidden="true"
                      style={{ fontSize: 16 }}
                    ></i>
                  </Link>
                  <ul>
                    <li>
                      <Link to="/services/aiml">AI/ML SOLUTIONS</Link>
                    </li>

                    <li>
                      <Link to="/services/webAppService">
                        APPLICATION ENGINEERING
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/cloudSolutions">CLOUD SOLUTIONS</Link>
                    </li>
                    <li>
                      <Link to="/services/digitalTransformation">
                        DIGITAL TRANSFORMATION
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/enterpriseService">
                        ENTERPRISES SOLUTIONS
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/itConsultingService">
                        IT CONSULTING
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="dropdown me-0 dropdown-link">
                  <Link to="" className="nav-link scrollto">
                    Industries
                    <i
                      class="fa fa-caret-down"
                      aria-hidden="true"
                      style={{ fontSize: 16 }}
                    ></i>
                  </Link>
                  <ul>
                    <li>
                      <Link to="/industries/automotive">AUTOMOTIVE</Link>
                    </li>
                    <li>
                      <Link to="/industries/banking&finance">BANKING</Link>
                    </li>
                    {/* <li>
                      <Link to="/industries/communications&information">
                        COMMUNICATION
                      </Link>
                    </li> */}
                    {/* {width > 980 ? (
                      <li className="nav-item dropdown me-0 dropdown-link p-0">
                        <Link to="">
                          SUPPLY CHAIN & LOGISTICS
                          <i
                            class="fa fa-caret-right"
                            aria-hidden="true"
                            style={{ fontSize: 16 }}
                          ></i>
                        </Link>
                        <ul>
                          <li>
                            <Link to="/industries/fleetManagement">
                              Fleet Management{" "}
                            </Link>
                          </li>
                          <li>
                            <Link to="/services/agenticAI">AGENTIC AI</Link>
                          </li>
                        </ul>
                      </li>
                    ) : (
                      <ReusableCollapse
                        header={<Link to="">SUPPLY CHAIN & LOGISTICS</Link>}
                      >
                        <div>
                          <li>
                            <Link to="/industries/fleetManagement">
                              FLEET MANAGEMENT{" "}
                            </Link>
                          </li>
                          <li>
                            <Link to="/services/agenticAI">AGENTIC AI</Link>
                          </li>
                        </div>
                      </ReusableCollapse>
                    )} */}
                    <li>
                      <Link to="/industries/healthcare">HEALTHCARE</Link>
                    </li>
                    <li>
                      <Link to="/industries/insurance">INSURANCE</Link>
                    </li>
                    <li>
                      <Link to="/industries/manufacturing">MANUFACTURING</Link>
                    </li>
                  </ul>
                </li>
                {/* <Nav.Link ><Link to='' style={linkStyle}>Ecosystem</Link></Nav.Link> */}

                <li className="dropdown me-0 dropdown-link">
                  <Link to="" className="nav-link scrollto">
                    Resources
                    <i
                      class="fa fa-caret-down"
                      aria-hidden="true"
                      style={{ fontSize: 16 }}
                    ></i>
                  </Link>

                  <ul>
                    {width > 980 ? (
                      <li className="nav-item dropdown me-0 dropdown-link p-0">
                        <Link to="">
                          Agentic AI Blogs
                          <i
                            class="fa fa-caret-down"
                            aria-hidden="true"
                            style={{ fontSize: 16 }}
                          ></i>
                        </Link>
                        <ul>
                          <li>
                            <Link to="/blog/how-agentic-ai-will-transform-healthcare-claims-automation-2026">
                              Agentic AI
                            </Link>
                          </li>
                          <li>
                            <Link to="/blog/agentic-ai-automation-qa-realistic-roi">
                              QA
                            </Link>
                          </li>
                        </ul>
                      </li>
                    ) : (
                      <ReusableCollapse
                        header={<Link to="">Agentic AI Blogs</Link>}
                      >
                        <div>
                          <li>
                            <Link to="/blog/how-agentic-ai-will-transform-healthcare-claims-automation-2026">
                              HealthCare Blog
                            </Link>
                          </li>
                          <li>
                            <Link to="/blog/agentic-ai-automation-qa-realistic-roi">
                              AgenticAI Blog
                            </Link>
                          </li>
                        </div>
                      </ReusableCollapse>
                    )}
                  </ul>
                </li>

                <li className="dropdown me-0 dropdown-link">
                  <Link to="" className="nav-link scrollto">
                    Company
                    <i
                      class="fa fa-caret-down"
                      aria-hidden="true"
                      style={{ fontSize: 16 }}
                    ></i>
                  </Link>

                  <ul>
                    <li>
                      <Link to="/about">ABOUT</Link>
                    </li>
                    <li>
                      <Link to="/careers">CAREERS</Link>
                    </li>
                    <li>
                      <Link to="/contactUs">CONTACT</Link>
                    </li>
                  </ul>
                </li>

                <Nav.Link>
                  <Link to="/insights">Insights</Link>
                </Nav.Link>
                <Nav.Link>
                  <Link to="/blog">Blog</Link>
                </Nav.Link>
                {/* <Nav.Link>
                  <Link to="/blog">Blog</Link>
                </Nav.Link>
                <Nav.Link>
                  <Link to="/casestudies">Case Studies</Link>
                </Nav.Link>
                <Nav.Link>
                  <Link to="/about">About</Link>
                </Nav.Link>
                <Nav.Link>
                  {" "}
                  <Link to="/careers">Careers</Link>
                </Nav.Link>
                <Nav.Link>
                  {" "}
                  <Link to="/contactUs">Contact</Link>
                </Nav.Link> */}
                {/* <Nav.Link><Link to='/enquiry'>Enquriy</Link></Nav.Link> */}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default NavComponent;
